module.exports = __webpack_public_path__ + "img/bicycleFrontLeft.0079ec3d.svg";